import React, { Component } from "react";
import { Button } from "config/initializers/styles.app";
import { getAppConfig } from "config/client.config";
import { Translations } from "config/app.translations";

import _ from "lodash";
import PropTypes from "prop-types";
import { VelocityTransitionGroup } from "velocity-react";

export default class MultiSelectButtonGroup extends Component {
    static propTypes = {
        options: PropTypes.array.isRequired,
        extractFrom: PropTypes.string.isRequired,
        colors: PropTypes.object,
        animation: PropTypes.string,
        submit: PropTypes.func.isRequired,
    };
    static defaultProps = {
        colors: {
            base: "#FFFFFF",
            primary: "#cb1f37",
            primaryVariation: "#a41817",
            secondary: "#ffaa00",
            secondaryVariation: "#4db6ac",
            baseText: "#121212",
            primaryText: "#ffffff",
            secondaryText: "#000000",
        },
        animation: "fadeIn, 500",
    };

    constructor(props) {
        super(props);
        this.state = {
            selectedOptions: [],
        };
    }

    handleOptionClick = (index) => {
        let list = this.state.selectedOptions;
        var idx = _.indexOf(list, index);
        if (idx !== -1) {
            list.splice(idx, 1);
        } else {
            list.push(index);
        }
        this.setState({ selectedOptions: list });
    };
    handleOnSubmit = () => {
        this.props.submit(this.state.selectedOptions);
        let list = [];
        this.setState({ selectedOptions: list });
    };

    handleOnSubmit = () => {
        this.props.submit(this.state.selectedOptions);
        let list = [];
        this.setState({ selectedOptions: list });
    };

    render() {
        let isPortrait =
            this.props.mobileView || window.innerHeight > window.innerWidth;
        let animation = this.props.animation.split(",");
        let getOptions = _.map(this.props.options, (option, index) => {
            let buttonStyle = {
                marginBottom: "5px",
            };
            return (
                <Button
                    key={"button-" + index}
                    style={buttonStyle}
                    fluid
                    size={isPortrait ? "medium" : "huge"}
                    onClick={() => this.handleOptionClick(index)}
                    content={option[this.props.extractFrom]}
                    labelPosition="left"
                    icon={
                        this.state.selectedOptions.indexOf(index) > -1
                            ? "checkmark"
                            : "square"
                    }
                />
            );
        });
        let templateTranslations = _.find(Translations, {
            language: "en",
        }).templateActions;

        return (
            <div>
                <Button.Group vertical>
                    <VelocityTransitionGroup
                        enter={{
                            animation: animation[0],
                            duration: animation[1],
                            stagger: animation[2],
                        }}
                        leave={{ animation: "fadeOut", duration: "0" }}
                        runOnMount
                    >
                        {getOptions}
                    </VelocityTransitionGroup>
                </Button.Group>
                <br />
                <VelocityTransitionGroup
                    enter={{
                        animation: "transition.bounceUpIn",
                        duration: "500",
                        delay: this.props.options.length * 500,
                    }}
                    leave={{ animation: "fadeOut", duration: "0" }}
                    runOnMount
                >
                    <Button
                        onClick={this.handleOnSubmit}
                        style={getAppConfig().secondaryButtonStyle}
                    >
                        {this.props.purpose === "quiz"
                            ? templateTranslations.checkAnswer
                            : templateTranslations.submitAnswer}
                    </Button>
                </VelocityTransitionGroup>
                <br />
                <br />
            </div>
        );
    }
}
